import { motion } from "framer-motion";
import { Shield, Clock, Award } from "lucide-react";

const ABOUT_IMAGE = "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80";

const stats = [
  { icon: Clock, value: "30+", label: "Anos de Experiência" },
  { icon: Shield, value: "100%", label: "Modelo B2B" },
  { icon: Award, value: "Atendimento", label: "Nacional" },
];

export const AboutSection = () => {
  return (
    <section id="sobre" data-testid="about-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div initial={{ opacity: 0, x: -40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img src={ABOUT_IMAGE} alt="Equipe Duali Soluções" className="w-full h-[400px] lg:h-[500px] object-cover" />
              <div className="absolute inset-0 bg-brand-navy/20" />
            </div>
            <motion.div initial={{ opacity: 0, scale: 0.8 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.4 }}
              className="absolute -bottom-6 -right-6 bg-brand-teal text-white p-6 rounded-2xl shadow-xl">
              <span className="text-3xl font-bold block">30+</span>
              <span className="text-sm font-medium opacity-90">Anos no Mercado</span>
            </motion.div>
          </motion.div>

          <motion.div initial={{ opacity: 0, x: 40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}>
            <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand-teal mb-4 block">Quem Somos</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-brand-navy mb-6" data-testid="about-title">
              Experiência que <span className="text-brand-teal">Transforma</span> Resultados
            </h2>
            <p className="text-base lg:text-lg text-slate-600 leading-relaxed mb-6">
              A Duali Soluções é uma consultoria B2B dedicada a revolucionar o mercado de Benefícios e Seguros. Com mais de três décadas de atuação no mercado brasileiro, entregamos inteligência de mercado, táticas comerciais assertivas e capacitação de alto nível para impulsionar o seu negócio.
            </p>
            <p className="text-base lg:text-lg text-slate-600 leading-relaxed mb-10">
              Entramos na empresa cliente, fazemos um raio-X da operação, identificamos os gargalos e entregamos a solução completa. Seja implantando um novo sistema, criando uma nova esteira de produtos ou reestruturando toda a estratégia comercial e de retenção.
            </p>
            <div className="grid grid-cols-3 gap-6">
              {stats.map((stat, i) => (
                <motion.div key={stat.label} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.2 + i * 0.1 }} className="text-center">
                  <stat.icon className="mx-auto mb-2 text-brand-teal" size={24} />
                  <div className="text-2xl font-bold text-brand-navy">{stat.value}</div>
                  <div className="text-xs text-slate-500 mt-1">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
